// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Js_string = require("@rescript/std/lib/js/js_string.js");
var Belt_Option = require("@rescript/std/lib/js/belt_Option.js");

function exnToString(exn) {
  return exn;
}

function fromError(error) {
  var arr = Belt_Option.map(error.message, (function (param) {
          return Js_string.split("|", param);
        }));
  if (arr === undefined) {
    return ;
  }
  if (arr.length !== 2) {
    return ;
  }
  var match = arr[0];
  if (match !== "ADS_ERROR") {
    return ;
  }
  var err = arr[1];
  if (err === "FirefoxStorage") {
    return {
            type: "ADS_ERROR",
            kind: "FirefoxStorage",
            error: error
          };
  }
  
}

exports.exnToString = exnToString;
exports.fromError = fromError;
/* No side effect */
